module.exports = __webpack_public_path__ + "static/media/drop.ad01f128.mp3";